module.exports = __webpack_public_path__ + "static/media/down.d96c13a5.svg";